import { Fragment, useEffect } from "react";

// import { useTranslation } from "react-i18next";
// import { useDispatch, useSelector } from "react-redux";
// import { getPolicy } from "../../store/about/aboutAction";
import img1 from "../../assets/images/project/project-3-img-4.jpg";
import img2 from "../../assets/images/project/recent-pro-img-3.jpg";
import img3 from "../../assets/images/project/recent-pro-img-2.jpg";
import bg from "../../assets/image/apply-bg.jpg";
import "swiper/css";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

// import mainbg from "../../assets/1.jpg";
// import img4 from "../../assets/review-bg.jpg";
// import Loader from "../../component/Loader";
// import { Link } from "react-router-dom";

const RegisterNow = () => {
  // const { t } = useTranslation();
  // const dispatch = useDispatch();
  // const lan = useSelector((state) => state.LanSlicer.language);
  // const { policy, loading } = useSelector((state) => state.aboutSlicer);

  // useEffect(() => {
  //   dispatch(getPolicy(lan));
  // }, [dispatch, lan]);

  return (
    <div className="counter position-relative">
      <div
        className="counter_background"
        style={{ backgroundImage: `url(${bg})` }}
      ></div>
      <div className="container">
        <div className="row row-counter ">
          <div className="col-lg-6 ">
            <div className="counter_content">
              <h2 className="counter_title">Register Now</h2>
              <div className="counter_text">
                <p>
                  Simply dummy text of the printing and typesetting industry.
                  Lorem Ipsum has been the industry’s standard dumy text ever
                  since the 1500s, when an unknown printer took a galley of type
                  and scrambled it to make a type specimen book.
                </p>
              </div>

              <div className="milestones d-flex flex-md-row flex-column align-items-center justify-content-between">
                <div className="milestone">
                  <div className="milestone_counter" data-end-value="15">
                    20
                  </div>
                  <div className="milestone_text">years</div>
                </div>

                <div className="milestone">
                  <div
                    className="milestone_counter"
                    data-end-value="120"
                    data-sign-after="k"
                  >
                    70
                  </div>
                  <div className="milestone_text">years</div>
                </div>

                <div className="milestone">
                  <div
                    className="milestone_counter"
                    data-end-value="670"
                    data-sign-after="+"
                  >
                    110
                  </div>
                  <div className="milestone_text">years</div>
                </div>

                <div className="milestone">
                  <div className="milestone_counter" data-end-value="320">
                    36
                  </div>
                  <div className="milestone_text">years</div>
                </div>
              </div>
            </div>
          </div>
          <div className="counter_form py-4 ">
            <div className="row fill_height py-3">
              <div className="col fill_height py-4">
                <form
                  className="counter_form_content d-flex flex-column align-items-center justify-content-center"
                  action="#"
                >
                  <div className="counter_form_title">courses now</div>
                  <input
                    type="text"
                    className="counter_input"
                    placeholder="Your Name:"
                    required="required"
                  />
                  <input
                    type="tel"
                    className="counter_input"
                    placeholder="Phone:"
                    required="required"
                  />
                  <select
                    name="counter_select"
                    id="counter_select"
                    className="counter_input counter_options"
                  >
                    <option>Choose Subject</option>
                    <option>Subject</option>
                    <option>Subject</option>
                    <option>Subject</option>
                  </select>
                  <textarea
                    className="counter_input counter_text_input"
                    placeholder="Message:"
                    required="required"
                  ></textarea>
                  <button type="submit" className="counter_form_button">
                    submit now
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterNow;
